import type { ListingFilter } from '../domain/models/Filter';

export type FilterApplySelectedOptions = Record<string, string[]>;

/**
 * Same shape as WebEngage/GA `Filter Applied` on PLP (category keys → comma-separated display names).
 */
export function buildFilterAppliedEventPayload(
  filters: ListingFilter[],
  selectedOptions: FilterApplySelectedOptions,
): Record<string, string> | null {
  const keys = Object.keys(selectedOptions);
  if (keys.length === 0) return null;
  const payload: Record<string, string> = {};
  for (const category of keys) {
    const names = selectedOptions[category];
    const filter = filters.find((f) => f.category === category);
    const displayNames = names.map((name) => {
      const item = filter?.items.find((i) => i.name === name);
      return item?.displayName ?? name;
    });
    payload[category] = displayNames.join(',');
  }
  return payload;
}
